import { lazy, Suspense, useEffect, useState } from "react";

const CreuseMapInner = lazy(() => import("./CreuseMapInner"));

export default function CreuseMap() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") setReady(true);
  }, []);

  return (
    <section id="carte" data-testid="creuse-map-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl mb-10">
          <div className="text-sm tracking-[0.25em] uppercase text-[#1B5E20] font-medium mb-4">Carte</div>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-light text-[#1A2E1C] tracking-tight">
            Toute la Creuse, <span className="font-medium text-[#1B5E20]">commune par commune</span>
          </h2>
          <p className="mt-4 text-[#5C705E]">Cliquez sur un point ou choisissez votre commune pour voir nos services près de chez vous.</p>
        </div>
        {ready ? (
          <Suspense fallback={<div className="h-[460px] md:h-[560px] rounded-3xl bg-[#F1F8F2] animate-pulse" />}>
            <CreuseMapInner />
          </Suspense>
        ) : (
          <div className="h-[460px] md:h-[560px] rounded-3xl bg-[#F1F8F2]" />
        )}
      </div>
    </section>
  );
}
